export const TaxRatesTableColumns = [
    {
        id: "name",
        labelEn: "Name",
        labelAr: "الاسم",
        align: "left",
        sortable: true,
    },
    {
        id: "rate_percent",
        labelEn: "Rate",
        labelAr: "النسبة",
        align: "center",
        sortable: false,
    },
    {
        id: "zone",
        labelEn: "Zone",
        labelAr: "المنطقة",
        align: "center",
        sortable: false,
    },
    {
        id: "is_active",
        labelEn: "Active",
        labelAr: "نشط",
        align: "center",
        sortable: false,
    },
];
